// Normaliza el campo `detail` de una respuesta de error del backend a un texto legible.
// FastAPI/Pydantic devuelve en 422 un array de objetos {type, loc, msg, input, url}.
// Renderizar ese objeto directamente en React provoca el crash "Minified React error #31".
export function parseApiError(detail, fallback = 'Ocurrió un error. Intenta nuevamente.') {
  if (detail == null) return fallback;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    const msgs = detail
      .map((item) => (typeof item === 'string' ? item : item?.msg))
      .filter(Boolean);
    return msgs.length ? msgs.join(' · ') : fallback;
  }
  if (typeof detail === 'object') {
    return detail.msg || detail.detail || fallback;
  }
  return String(detail) || fallback;
}
